import './accordion-v2.scss'

import React, { useState } from 'react'

import { AccordionV2 } from './AccordionV2'
import { distributeListInColumns } from '../../../../utils/array/distributeListInColumns'

import type { HandleSelectAccordionOption } from './AccordionV2'

interface AccordionV2ListProps<TAccordion> {
  listAccordion: TAccordion[]
  render: (accordion: TAccordion) => {
    title: string
    contentInternal?: React.ReactNode
    childrenTitle?: React.ReactNode
  }
  handleSelect?: HandleSelectAccordionOption
  isArrow?: boolean
  columnQuantity?: number
  openItemDefault?: string
}

export function AccordionV2List<TAccordion>({
  listAccordion,
  render,
  handleSelect,
  isArrow = true,
  columnQuantity,
  openItemDefault,
}: AccordionV2ListProps<TAccordion>) {
  const [selectedTitle, setSelectedTitle] = useState<string>()

  return (
    <div className="accordionV2-list">
      {columnQuantity
        ? distributeListInColumns(listAccordion, columnQuantity)?.map(
            (groupAccordion, groupAccordionIndex) => (
              <div className="accordionV2-column" key={groupAccordionIndex}>
                {groupAccordion?.map((itemAccordion) => {
                  const accordion = render(itemAccordion)

                  return (
                    <AccordionV2
                      key={accordion?.title}
                      selectedTitle={selectedTitle}
                      setSelectedTitle={setSelectedTitle}
                      title={accordion?.title}
                      handleSelect={handleSelect}
                      isArrow={isArrow}
                      childrenTitle={accordion?.childrenTitle}
                      openItemDefault={openItemDefault}
                    >
                      {accordion?.contentInternal}
                    </AccordionV2>
                  )
                })}
              </div>
            )
          )
        : listAccordion?.map((itemAccordion) => {
            const accordion = render(itemAccordion)

            return (
              <AccordionV2
                key={accordion?.title}
                selectedTitle={selectedTitle}
                setSelectedTitle={setSelectedTitle}
                title={accordion?.title}
                handleSelect={handleSelect}
                isArrow={isArrow}
                childrenTitle={accordion?.childrenTitle}
                openItemDefault={openItemDefault}
              >
                {accordion?.contentInternal}
              </AccordionV2>
            )
          })}
    </div>
  )
}
